// 依据收票宝专项第三方信息共享清单；新版文档日期待确认，暂保留现有日期。
export default {
  updatedAt: "2026年04月16日",
  publishedAt: "2026年04月16日",
  effectiveAt: "2026年04月16日",
  introduction: [
    "为了保障收票宝小程序相关功能的实现和安全稳定运行，我们会接入由第三方提供的软件开发工具包（SDK）、应用程序接口（API）或小程序平台能力，以实现相关功能和服务。",
    "我们会对合作方提供的软件开发工具包（SDK）、应用程序接口（API）及相关平台能力进行严格的安全监测，并要求合作方采取必要的数据保护措施，以保障您的个人信息安全。",
    "我们将在本页面中分别列明收票宝小程序接入的第三方SDK、API及相关服务。请注意，第三方服务可能因版本升级、策略调整等原因，导致其收集、处理的个人信息类型发生变化，具体请以第三方公示的官方说明为准。",
  ],
  services: [
    {
      name: "微信JS-SDK/微信开放能力",
      purpose:
        "用于实现收票宝H5与小程序页面之间的跳转，以及聊天/卡包导入回跳等场景。",
      information:
        "页面路径及跳转参数；聊天/卡包导入的跳转参数中含业务登录令牌。",
      privacyUrl: "https://www.tencent.com/zh-cn/privacy-policy.html",
      provider: "深圳市腾讯计算机系统有限公司",
    },
    {
      name: "微信小程序接口",
      purpose:
        "用于为您提供微信登录、手机号授权、聊天文件选择、卡包发票选择及邀请分享等功能；接入方式为 pages/index、pages/login、options 等页面及参数，邀请分享可由微信菜单或首页推广图进入。聊天导入仅处理用户主动选择的文件，不读取全部聊天记录。",
      information:
        "登录凭证、微信账号标识、授权登录信息、经您授权提供的手机号、您主动选择的聊天文件/图片/卡包发票信息，以及邀请分享的标题、图片和目标路径。",
      privacyUrl: "https://www.tencent.com/zh-cn/privacy-policy.html",
      provider: "深圳市腾讯计算机系统有限公司",
    },
  ],
};
